import React, { useState, useRef } from 'react';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ContextualHelpModule } from '@qbe/ads-blocks-forms';
import { IconButton, styled } from '@qbe/ads-core';

interface InformationPopUpProps {
  message?: string;
}

const InformationPopUpWrapper = styled('div')`
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: 5px;
`;

const StyledContextualHelpModule = styled(ContextualHelpModule)`
  .contextual-help-module-container {
    background-color: #fff;
  }
  .contextual-help-module-container .contextual-help-module-content {
    font-weight: normal;
    font-size: 1rem;
  }
  .contextual-help-module-container svg > path {
    color: #000;
    box-shadow: none;
    border-radius: 50%;
  }
`;

export const InformationPopUp = ({ message }: InformationPopUpProps) => {
  const [show, toggle] = useState(false);
  const ref = useRef(null);
  const { isMobile } = useBreakpoint();

  useOnClickOutside(ref, () => isMobile && toggle(false));

  return (
    <InformationPopUpWrapper>
      <IconButton
        data-track={message}
        iconProps={{
          muiIcon: InfoOutlinedIcon,
        }}
        onClick={() => toggle(!show)}
      />
      <StyledContextualHelpModule
        isOpen={show}
        handleClose={() => {
          toggle(!show);
        }}
        offsetX="620px"
      >
        {message}
      </StyledContextualHelpModule>
    </InformationPopUpWrapper>
  );
};

export default InformationPopUp;
